var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9999 8.33332L11.6666 4.99999M2.08325 17.9167L4.90356 17.6033C5.24814 17.565 5.42042 17.5458 5.58146 17.4937C5.72433 17.4475 5.86029 17.3822 5.98566 17.2995C6.12696 17.2062 6.24954 17.0837 6.49469 16.8386L17.4999 5.83332C18.4204 4.91285 18.4204 3.42046 17.4999 2.49999C16.5794 1.57951 15.0871 1.57951 14.1666 2.49999L3.16136 13.5052C2.91621 13.7504 2.79363 13.8729 2.70045 14.0142C2.61778 14.1397 2.55243 14.2756 2.50618 14.4185C2.45405 14.5795 2.4349 14.7517 2.39662 15.0963L2.08325 17.9167Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditaction);
export default __webpack_public_path__ + "static/media/editaction.55ec3e3348a3de370c481493473e7d10.svg";
export { ForwardRef as ReactComponent };